import httpClient from "@/store/httpClient";

export default {
    namespaced: true,
    actions: {
        // eslint-disable-next-line no-unused-vars
        async sendSignupMessage(_, payload) {
            await httpClient.post("/mobile-mapping/message", payload);
        }
    }
}